var _defs, _path, _path2, _circle, _line, _path3, _g, _rect, _circle2, _g2, _g3, _circle3, _line2, _line3, _path4, _g4, _circle4, _path5, _circle5, _line4, _line5, _path6, _g5, _circle6, _path7, _g6, _g7, _line6, _path8, _rect2, _g8, _g9, _g10, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path9, _g11, _circle7, _circle8, _g12, _g13, _g14, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _g15, _g16, _rect3, _rect4, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _path10, _g17, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 2438.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-14, .cls-8, .cls-10, .cls-11, .cls-15, .cls-12, .cls-13 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-4, .cls-15 {\n        stroke-width: 2px;\n      }\n\n      .cls-2, .cls-6, .cls-8 {\n        stroke: #d82163;\n      }\n\n      .cls-3, .cls-4, .cls-7, .cls-14, .cls-9, .cls-15, .cls-12, .cls-13 {\n        stroke: #0077a8;\n      }\n\n      .cls-3, .cls-11 {\n        stroke-width: .5px;\n      }\n\n      .cls-5, .cls-6, .cls-9, .cls-13 {\n        stroke-width: 3px;\n      }\n\n      .cls-5, .cls-10, .cls-11 {\n        stroke: #22d674;\n      }\n\n      .cls-7, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-14, .cls-12 {\n        stroke-width: 5px;\n      }\n\n      .cls-15 {\n        fill: #e89e7f;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-17 {\n        fill: #0077a8;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1717.47,
    cy: 900.99,
    rx: 28.54,
    ry: 154.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M509.74,1402.72h4.1c7.86,0,14.24,6.37,14.24,14.24h0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1707.8,128.6h-44.98v.02c-.07,0-.13-.02-.2-.02-11.22,0-20.31,83.15-20.31,185.71s9.09,185.71,20.31,185.71c.07,0,.13-.02.2-.02v.02h44.98c11.22,0,20.31-83.15,20.31-185.71s-9.09-185.71-20.31-185.71ZM1682.9,323.84c.02-3.16.03-6.33.03-9.53s0-6.37-.03-9.53c.02,3.16.03,6.33.03,9.53s0,6.37-.03,9.53ZM1673.26,472.55s0,0,0-.01c0,0,0,0,0,.01ZM1673.67,470.18s0-.03,0-.04c0,.01,0,.03,0,.04ZM1674.07,467.71s0-.02,0-.03c0,0,0,.02,0,.03ZM1674.47,465.17s.01-.07.02-.1c0,.03-.01.07-.02.1ZM1674.86,462.55s.01-.1.02-.15c0,.05-.01.1-.02.15ZM1675.24,459.83s.01-.1.02-.15c0,.05-.01.1-.02.15ZM1675.61,457.05c0-.08.02-.15.03-.23,0,.08-.02.15-.03.23ZM1675.98,454.18c.01-.1.02-.2.04-.29-.01.1-.02.2-.04.29ZM1676.34,451.23c.01-.1.02-.21.04-.31-.01.1-.02.21-.04.31ZM1676.69,448.2c.01-.12.03-.24.04-.36-.01.12-.03.24-.04.36ZM1677.04,445.11c.02-.15.03-.29.05-.44-.02.15-.03.29-.05.44ZM1677.38,441.92c.02-.15.03-.3.05-.44-.02.15-.03.3-.05.44ZM1677.7,438.67c.02-.16.03-.32.05-.48-.02.16-.03.32-.05.48ZM1678.02,435.36c.02-.2.04-.4.06-.6-.02.2-.04.4-.06.6ZM1678.33,431.97c.02-.22.04-.45.06-.67-.02.22-.04.45-.06.67ZM1678.64,428.52c.02-.26.04-.52.06-.77-.02.26-.04.52-.06.77ZM1678.93,424.99c.02-.26.04-.53.06-.8-.02.27-.04.54-.06.8ZM1679.21,421.41c.02-.31.05-.62.07-.93-.02.31-.05.62-.07.93ZM1679.49,417.74c.02-.31.05-.63.07-.95-.02.31-.05.63-.07.95ZM1679.76,414.02c.02-.34.05-.68.07-1.02-.02.34-.05.68-.07,1.02ZM1680.01,410.25c.02-.36.05-.73.07-1.1-.02.37-.05.74-.07,1.1ZM1680.26,406.39c.02-.35.04-.7.06-1.05-.02.35-.04.7-.06,1.05ZM1680.5,402.49c.02-.39.05-.78.07-1.17-.02.39-.04.79-.07,1.17ZM1680.72,398.55c.02-.44.05-.89.07-1.33-.02.44-.05.89-.07,1.33ZM1680.94,394.53c.03-.48.05-.96.07-1.44-.02.48-.05.97-.07,1.44ZM1681.15,390.48c.03-.54.05-1.09.08-1.63-.03.54-.05,1.09-.08,1.63ZM1681.34,386.35c.02-.53.05-1.06.07-1.59-.02.53-.05,1.06-.07,1.59ZM1681.53,382.17c.02-.54.04-1.08.07-1.62-.02.54-.04,1.08-.07,1.62ZM1681.71,377.95c.02-.58.05-1.17.07-1.75-.02.58-.04,1.17-.07,1.75ZM1681.87,373.67c.02-.58.04-1.17.06-1.75-.02.58-.04,1.17-.06,1.75ZM1682.02,369.34c.02-.6.04-1.21.06-1.82-.02.61-.04,1.21-.06,1.82ZM1682.16,364.99c.02-.69.04-1.39.06-2.09-.02.7-.04,1.4-.06,2.09ZM1682.29,360.59c.02-.73.04-1.47.06-2.21-.02.74-.04,1.48-.06,2.21ZM1682.41,356.12c.02-.74.04-1.48.05-2.23-.02.74-.03,1.49-.05,2.23ZM1682.52,351.63c.02-.8.03-1.6.05-2.4-.02.8-.03,1.6-.05,2.4ZM1682.61,347.09c.02-.82.03-1.65.04-2.48-.01.83-.03,1.65-.04,2.48ZM1682.7,342.51c.01-.78.02-1.56.04-2.34-.01.78-.02,1.57-.04,2.34ZM1682.77,337.89c.01-.76.02-1.53.03-2.29,0,.76-.02,1.53-.03,2.29ZM1682.82,333.24c0-.76.01-1.53.02-2.3,0,.77-.01,1.53-.02,2.3ZM1682.87,328.55c0-.8.01-1.6.02-2.4,0,.8-.01,1.6-.02,2.4ZM1673.26,156.08s0,0,0,.01c0,0,0,0,0-.01ZM1673.67,158.45s0,.03,0,.04c0-.01,0-.03,0-.04ZM1674.07,160.92s0,.02,0,.03c0,0,0-.02,0-.03ZM1674.47,163.45s.01.07.02.1c0-.03-.01-.07-.02-.1ZM1674.86,166.08s.01.1.02.15c0-.05-.01-.1-.02-.15ZM1675.24,168.8s.01.1.02.15c0-.05-.01-.1-.02-.15ZM1675.61,171.58c0,.08.02.15.03.23,0-.08-.02-.15-.03-.23ZM1675.98,174.45c.01.1.02.2.04.29-.01-.1-.02-.2-.04-.29ZM1676.34,177.4c.01.1.02.21.04.31-.01-.1-.02-.21-.04-.31ZM1676.69,180.43c.01.12.03.24.04.36-.01-.12-.03-.24-.04-.36ZM1677.04,183.52c.02.15.03.29.05.44-.02-.15-.03-.29-.05-.44ZM1677.38,186.71c.02.15.03.3.05.44-.02-.15-.03-.3-.05-.44ZM1677.7,189.96c.02.16.03.32.05.48-.02-.16-.03-.32-.05-.48ZM1678.02,193.27c.02.2.04.4.06.6-.02-.2-.04-.4-.06-.6ZM1678.33,196.66c.02.22.04.45.06.67-.02-.22-.04-.45-.06-.67ZM1678.64,200.11c.02.26.04.52.06.77-.02-.26-.04-.52-.06-.77ZM1678.93,203.64c.02.26.04.53.06.8-.02-.27-.04-.54-.06-.8ZM1679.21,207.22c.02.31.05.62.07.93-.02-.31-.05-.62-.07-.93ZM1679.49,210.88c.02.31.05.63.07.95-.02-.31-.05-.63-.07-.95ZM1679.76,214.61c.02.34.05.68.07,1.02-.02-.34-.05-.68-.07-1.02ZM1680.01,218.38c.02.36.05.73.07,1.1-.02-.37-.05-.74-.07-1.1ZM1680.26,222.24c.02.35.04.7.06,1.05-.02-.35-.04-.7-.06-1.05ZM1680.5,226.13c.02.39.05.78.07,1.17-.02-.39-.04-.79-.07-1.17ZM1680.72,230.08c.02.44.05.89.07,1.33-.02-.44-.05-.89-.07-1.33ZM1680.94,234.1c.03.48.05.96.07,1.44-.02-.48-.05-.97-.07-1.44ZM1681.15,238.14c.03.54.05,1.09.08,1.63-.03-.54-.05-1.09-.08-1.63ZM1681.34,242.28c.02.53.05,1.06.07,1.59-.02-.53-.05-1.06-.07-1.59ZM1681.53,246.46c.02.54.04,1.08.07,1.62-.02-.54-.04-1.08-.07-1.62ZM1681.71,250.68c.02.58.05,1.17.07,1.75-.02-.58-.04-1.17-.07-1.75ZM1681.87,254.96c.02.58.04,1.17.06,1.75-.02-.58-.04-1.17-.06-1.75ZM1682.02,259.28c.02.6.04,1.21.06,1.82-.02-.61-.04-1.21-.06-1.82ZM1682.16,263.64c.02.69.04,1.39.06,2.09-.02-.7-.04-1.4-.06-2.09ZM1682.29,268.04c.02.73.04,1.47.06,2.21-.02-.74-.04-1.48-.06-2.21ZM1682.41,272.51c.02.74.04,1.48.05,2.23-.02-.74-.03-1.49-.05-2.23ZM1682.52,277c.02.8.03,1.6.05,2.4-.02-.8-.03-1.6-.05-2.4ZM1682.61,281.53c.02.82.03,1.65.04,2.48-.01-.83-.03-1.65-.04-2.48ZM1682.7,286.11c.01.78.02,1.56.04,2.34-.01-.78-.02-1.57-.04-2.34ZM1682.77,290.74c.01.76.02,1.53.03,2.29,0-.76-.02-1.53-.03-2.29ZM1682.82,295.39c0,.76.01,1.53.02,2.3,0-.77-.01-1.53-.02-2.3ZM1682.87,300.08c0,.8.01,1.6.02,2.4,0-.8-.01-1.6-.02-2.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 969.69,
    cy: 1986.04,
    r: 185.78
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 969.69,
    y1: 2192.8,
    x2: 969.69,
    y2: 2348.58
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M969.69,2171.82c-2.21,0-4.42-.05-6.61-.13l2.67,21.11h7.88l2.67-21.11c-2.2.08-4.4.13-6.61.13Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 847.83,
    y: 1899.92,
    width: 34.73,
    height: 172.24,
    rx: 16.46,
    ry: 16.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1056.82,
    y: 1899.92,
    width: 34.73,
    height: 172.24,
    rx: 16.46,
    ry: 16.46
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 908.5,
    y: 1972.82,
    width: 122.39,
    height: 26.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 969.69,
    cy: 1986.04,
    r: 171.09
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M811.46,2055.65l-7.55-61.45h0c9.71.36,17.77,7.62,19.14,17.24l1.57,56.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M796.52,2043.57l-5.45-39.91.31-.02c7.69-.44,14.41,5.15,15.38,12.79l4.7,39.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M821.13,2063.77l-1.95-30.44c-.21-3.24.99-6.41,3.29-8.71l25.71-25.71h0c6.68,6.68,6.68,17.5,0,24.17l-7.08,7.08c-1.34,1.34-1.94,3.25-1.61,5.12l2.67,15.04c.88,4.94,3.25,9.5,6.8,13.05l2.8,2.8c2.99,2.99,7.05,4.67,11.28,4.67h2.11c4.23,0,8.29-1.68,11.28-4.67l1.29-1.29c5.83-5.83,15.28-5.83,21.1,0h0s-38.4,38.4-38.4,38.4c-5.75,5.75-8.91,13.59-8.75,21.72l.45,23h-48.46l-1.73-57.89c-.46-15.21-6.7-29.68-17.46-40.44l-17.1-17.1h0c6.27-6.27,16.43-6.27,22.7,0l5.23,5.23"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 795.37,
    y1: 2035.13,
    x2: 797.06,
    y2: 2046.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 811.58,
    y1: 2056.73,
    x2: 809.95,
    y2: 2043.05
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1128.2,2055.65l7.55-61.45h0c-9.71.36-17.77,7.62-19.14,17.24l-1.57,56.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1143.14,2043.57l5.45-39.91-.31-.02c-7.69-.44-14.41,5.15-15.38,12.79l-4.7,39.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1118.53,2063.77l1.95-30.44c.21-3.24-.99-6.41-3.29-8.71l-25.71-25.71h0c-6.68,6.68-6.68,17.5,0,24.17l7.08,7.08c1.34,1.34,1.94,3.25,1.61,5.12l-2.67,15.04c-.88,4.94-3.25,9.5-6.8,13.05l-2.8,2.8c-2.99,2.99-7.05,4.67-11.28,4.67h-2.11c-4.23,0-8.29-1.68-11.28-4.67l-1.29-1.29c-5.83-5.83-15.28-5.83-21.1,0h0s38.4,38.4,38.4,38.4c5.75,5.75,8.91,13.59,8.75,21.72l-.45,23h48.46s1.73-57.89,1.73-57.89c.46-15.21,6.7-29.68,17.46-40.44l17.1-17.1h0c-6.27-6.27-16.43-6.27-22.7,0l-5.23,5.23"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 1144.29,
    y1: 2035.13,
    x2: 1142.6,
    y2: 2046.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 1128.08,
    y1: 2056.73,
    x2: 1129.71,
    y2: 2043.05
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 551.53,
    cy: 314.38,
    r: 185.78
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 551.53,
    y1: 521.13,
    x2: 551.53,
    y2: 676.92
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 591.09,
    y1: 191.97,
    x2: 591.09,
    y2: 191.97
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M551.53,500.16c-2.21,0-4.42-.05-6.61-.13l2.67,21.11h7.88l2.67-21.11c-2.2.08-4.4.13-6.61.13Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M611.02,433.58h4.56v-8.06c0-2.74.91-4.18,3.65-4.18h1.82v-3.42h-3.12c-4.56,0-6.99,1.6-6.99,6.16v9.5h.08ZM604.4,427.04v2.36c0,.76-.3,1.06-1.06,1.06h-3.95c-.91,0-1.37-.68-1.37-1.67s.53-1.75,1.37-1.75h5.02,0ZM594.52,417.92v3.27h7.91c.91-.15,1.82.53,1.98,1.44v1.14h-7.07c-2.81,0-3.88,1.9-3.88,4.87,0,3.27,1.06,4.87,3.88,4.87h8.74c1.9,0,2.96-1.06,2.96-2.96v-7.6c0-2.96-1.75-4.94-4.87-4.94h-9.65v-.08ZM593.46,417.92h-4.64l-4.71,10.95-4.64-10.95h-4.71l7.22,15.58-2.43,5.09h4.64l9.27-20.68ZM574.6,417.92h-4.64l-4.79,10.95-4.56-10.95h-4.79l7.22,15.58-2.43,5.09h4.64s9.35-20.68,9.35-20.68ZM551.19,427.04v2.36c0,.76-.3,1.06-1.06,1.06h-3.95c-.91,0-1.37-.68-1.37-1.67s.53-1.75,1.37-1.75h5.02ZM541.31,417.92v3.27h7.91c.91-.15,1.82.53,1.98,1.44v1.14h-7.07c-2.81,0-3.88,1.9-3.88,4.87,0,3.27,1.06,4.87,3.88,4.87h8.74c1.9,0,2.96-1.06,2.96-2.96v-7.6c0-2.96-1.75-4.94-4.87-4.94h-9.65v-.08ZM526.63,417.92h-4.79l6.31,14.44c.61,1.29,1.82,1.37,2.89,1.37s2.28-.08,2.89-1.37l6.31-14.44h-4.79l-3.95,10.34c-.08.23-.23.53-.38.53s-.3-.38-.38-.53l-4.11-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M496.68,415.71l-14.67,8.44,16.5,9.58c1.14-3.04,1.67-6.31,1.67-9.58s-.61-6.46-1.67-9.5l-1.82,1.06ZM501.24,413.05c4.56,6.69,4.56,15.43,0,22.12l11.71,6.84v-35.73l-11.71,6.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M531.98,454.47l1.74.94c-.53.74-1.19,1.32-2,1.76-.81.44-1.69.66-2.63.66-1.07,0-2.04-.28-2.92-.82-.88-.55-1.58-1.29-2.1-2.21s-.78-1.95-.78-3.07c0-.85.15-1.65.45-2.39.3-.74.72-1.39,1.25-1.95.53-.56,1.15-1,1.85-1.32s1.46-.48,2.25-.48c.94,0,1.82.22,2.63.66.81.44,1.48,1.03,2,1.78l-1.74.94c-.37-.46-.81-.81-1.32-1.06s-1.03-.37-1.57-.37c-.72,0-1.37.19-1.96.57s-1.05.89-1.39,1.53-.51,1.33-.51,2.08.17,1.44.52,2.07.81,1.14,1.39,1.52c.58.38,1.23.57,1.94.57.57,0,1.11-.13,1.61-.39.5-.26.93-.6,1.28-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M544.94,445.92h1.95v11.61h-1.95l-.08-1.96c-.36.67-.87,1.22-1.5,1.64-.64.42-1.4.63-2.28.63s-1.65-.16-2.39-.48c-.74-.32-1.4-.77-1.97-1.34s-1.01-1.23-1.33-1.97c-.32-.74-.48-1.54-.48-2.4s.15-1.61.46-2.35c.31-.74.74-1.38,1.29-1.93.55-.55,1.19-.99,1.92-1.3.73-.31,1.51-.47,2.35-.47.91,0,1.71.21,2.4.64s1.25.99,1.67,1.67l-.07-1.99ZM541.04,455.94c.77,0,1.43-.19,1.99-.56.56-.38.99-.88,1.3-1.53s.46-1.35.46-2.13-.15-1.5-.46-2.14c-.31-.64-.74-1.15-1.31-1.52-.56-.38-1.22-.56-1.98-.56s-1.46.19-2.09.57c-.63.38-1.12.89-1.49,1.53-.37.64-.55,1.35-.55,2.13s.19,1.49.57,2.13c.38.64.88,1.15,1.51,1.52.63.38,1.31.56,2.05.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M549.21,457.53v-11.61h1.95v1.45c.41-.54.93-.97,1.56-1.29.63-.32,1.31-.48,2.04-.48.45,0,.88.06,1.3.17l-.79,1.95c-.32-.1-.63-.15-.93-.15-.58,0-1.11.14-1.6.42s-.87.66-1.16,1.14c-.29.48-.43,1.01-.43,1.6v6.79h-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M562,457.83c-1.07,0-2.04-.28-2.92-.82-.88-.55-1.58-1.29-2.1-2.21s-.78-1.95-.78-3.07c0-.85.15-1.65.45-2.39.3-.74.72-1.39,1.25-1.95.53-.56,1.15-1,1.85-1.32s1.46-.48,2.25-.48c.88,0,1.68.18,2.41.53.73.35,1.36.84,1.88,1.47s.91,1.35,1.17,2.18c.26.83.35,1.71.28,2.66h-9.47c.09.66.31,1.24.65,1.76.34.51.78.92,1.31,1.22.53.3,1.12.46,1.77.46.7,0,1.33-.18,1.89-.54.56-.36,1.02-.85,1.37-1.48l1.99.46c-.46,1.03-1.17,1.87-2.1,2.53-.94.65-1.99.98-3.15.98ZM558.21,450.9h7.57c-.06-.65-.27-1.24-.63-1.78-.36-.54-.81-.97-1.36-1.29-.55-.32-1.15-.49-1.8-.49s-1.25.16-1.79.48c-.54.32-.99.75-1.34,1.28-.35.54-.57,1.14-.66,1.81Z"
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 551.53,
    cy: 174.55,
    r: 2.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M551.53,119.71c-107.51,0-194.67,87.16-194.67,194.67s84.21,191.68,189.19,194.59l-1.13-8.94c2.2.08,4.4.13,6.61.13s4.42-.05,6.61-.13l-1.13,8.94c104.98-2.9,189.19-88.91,189.19-194.59s-87.16-194.67-194.67-194.67Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1577.8,
    cy: 1986.04,
    r: 185.78
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1577.8,
    y1: 2192.8,
    x2: 1577.8,
    y2: 2348.58
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1617.36,
    y1: 1853.63,
    x2: 1617.36,
    y2: 1853.63
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1577.8,2171.82c-2.21,0-4.42-.05-6.61-.13l2.67,21.11h7.88l2.67-21.11c-2.2.08-4.4.13-6.61.13Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1637.29,2105.24h4.56v-8.06c0-2.74.91-4.18,3.65-4.18h1.82v-3.42h-3.12c-4.56,0-6.99,1.6-6.99,6.16v9.5h.08ZM1630.67,2098.71v2.36c0,.76-.3,1.06-1.06,1.06h-3.95c-.91,0-1.37-.68-1.37-1.67s.53-1.75,1.37-1.75h5.02,0ZM1620.79,2089.58v3.27h7.91c.91-.15,1.82.53,1.98,1.44v1.14h-7.07c-2.81,0-3.88,1.9-3.88,4.87,0,3.27,1.06,4.87,3.88,4.87h8.74c1.9,0,2.96-1.06,2.96-2.96v-7.6c0-2.96-1.75-4.94-4.87-4.94h-9.65v-.08ZM1619.72,2089.58h-4.64l-4.71,10.95-4.64-10.95h-4.71l7.22,15.58-2.43,5.09h4.64l9.27-20.68ZM1600.87,2089.58h-4.64l-4.79,10.95-4.56-10.95h-4.79l7.22,15.58-2.43,5.09h4.64s9.35-20.68,9.35-20.68ZM1577.46,2098.71v2.36c0,.76-.3,1.06-1.06,1.06h-3.95c-.91,0-1.37-.68-1.37-1.67s.53-1.75,1.37-1.75h5.02ZM1567.57,2089.58v3.27h7.91c.91-.15,1.82.53,1.98,1.44v1.14h-7.07c-2.81,0-3.88,1.9-3.88,4.87,0,3.27,1.06,4.87,3.88,4.87h8.74c1.9,0,2.96-1.06,2.96-2.96v-7.6c0-2.96-1.75-4.94-4.87-4.94h-9.65v-.08ZM1552.9,2089.58h-4.79l6.31,14.44c.61,1.29,1.82,1.37,2.89,1.37s2.28-.08,2.89-1.37l6.31-14.44h-4.79l-3.95,10.34c-.08.23-.23.53-.38.53s-.3-.38-.38-.53c0,0-4.11-10.34-4.11-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1522.95,2087.38l-14.67,8.44,16.5,9.58c1.14-3.04,1.67-6.31,1.67-9.58s-.61-6.46-1.67-9.5l-1.82,1.06ZM1527.51,2084.72c4.56,6.69,4.56,15.43,0,22.12l11.71,6.84v-35.73l-11.71,6.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1558.25,2126.13l1.74.94c-.53.74-1.19,1.32-2,1.76-.81.44-1.69.66-2.63.66-1.07,0-2.04-.28-2.92-.82-.88-.55-1.58-1.29-2.1-2.21-.52-.93-.78-1.95-.78-3.07,0-.85.15-1.65.45-2.39.3-.74.72-1.39,1.25-1.95.53-.56,1.15-1,1.85-1.32s1.46-.48,2.25-.48c.94,0,1.82.22,2.63.66.81.44,1.48,1.03,2,1.78l-1.74.94c-.37-.46-.81-.81-1.32-1.06s-1.03-.37-1.57-.37c-.72,0-1.37.19-1.96.57s-1.05.89-1.39,1.53-.51,1.33-.51,2.08.17,1.44.52,2.07.81,1.14,1.39,1.52c.58.38,1.23.57,1.94.57.57,0,1.11-.13,1.61-.39.5-.26.93-.6,1.28-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1571.21,2117.58h1.95v11.61h-1.95l-.08-1.96c-.36.67-.87,1.22-1.5,1.64-.64.42-1.4.63-2.28.63s-1.65-.16-2.39-.48c-.74-.32-1.4-.77-1.97-1.34-.57-.57-1.01-1.23-1.33-1.97-.32-.74-.48-1.54-.48-2.4s.15-1.61.46-2.35c.31-.74.74-1.38,1.29-1.93.55-.55,1.19-.99,1.92-1.3.73-.31,1.51-.47,2.35-.47.91,0,1.71.21,2.4.64s1.25.99,1.67,1.67l-.07-1.99ZM1567.31,2127.6c.77,0,1.43-.19,1.99-.56.56-.38.99-.88,1.3-1.53s.46-1.35.46-2.13-.15-1.5-.46-2.14c-.31-.64-.74-1.15-1.31-1.52-.56-.38-1.22-.56-1.98-.56s-1.46.19-2.09.57c-.63.38-1.12.89-1.49,1.53-.37.64-.55,1.35-.55,2.13s.19,1.49.57,2.13c.38.64.88,1.15,1.51,1.52.63.38,1.31.56,2.05.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1575.48,2129.19v-11.61h1.95v1.45c.41-.54.93-.97,1.56-1.29.63-.32,1.31-.48,2.04-.48.45,0,.88.06,1.3.17l-.79,1.95c-.32-.1-.63-.15-.93-.15-.58,0-1.11.14-1.6.42s-.87.66-1.16,1.14c-.29.48-.43,1.01-.43,1.6v6.79h-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1588.26,2129.5c-1.07,0-2.04-.28-2.92-.82-.88-.55-1.58-1.29-2.1-2.21s-.78-1.95-.78-3.07c0-.85.15-1.65.45-2.39.3-.74.72-1.39,1.25-1.95.53-.56,1.15-1,1.85-1.32.7-.32,1.46-.48,2.25-.48.88,0,1.68.18,2.41.53.73.35,1.36.84,1.88,1.47s.91,1.35,1.17,2.18c.26.83.35,1.71.28,2.66h-9.47c.09.66.31,1.24.65,1.76.34.51.78.92,1.31,1.22.53.3,1.12.46,1.77.46.7,0,1.33-.18,1.89-.54.56-.36,1.02-.85,1.37-1.48l1.99.46c-.46,1.03-1.17,1.87-2.1,2.53-.94.65-1.99.98-3.15.98ZM1584.48,2122.56h7.57c-.06-.65-.27-1.24-.63-1.78-.36-.54-.81-.97-1.36-1.29-.55-.32-1.15-.49-1.8-.49s-1.25.16-1.79.48c-.54.32-.99.75-1.34,1.28-.35.54-.57,1.14-.66,1.81Z"
  })))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1577.8,
    cy: 1836.21,
    r: 2.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1577.8,1791.37c-107.51,0-194.67,87.16-194.67,194.67s84.21,191.68,189.19,194.59l-1.13-8.94c2.2.08,4.4.13,6.61.13s4.42-.05,6.61-.13l-1.13,8.94c104.98-2.9,189.19-88.91,189.19-194.59s-87.16-194.67-194.67-194.67Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1354.82,2052.44l-3.96-47.46c-.33-3.98,2.63-7.48,6.61-7.81h0c3.98-.33,7.48,2.63,7.81,6.61l4.51,54.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1369.29,2052.44l-1.45-63.07c-.09-3.99,3.07-7.31,7.07-7.4h0c3.99-.09,7.31,3.07,7.4,7.07l1.53,66.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1383.75,2052.44l2.33-71.6c.13-3.99,3.47-7.13,7.47-7h0c3.99.13,7.13,3.47,7,7.47l-2.33,71.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1398.22,2052.44l4.83-62.9c.31-3.98,3.78-6.97,7.77-6.66h0c3.98.31,6.97,3.78,6.66,7.77l-3.86,62.51c-.31,5.04,3.69,9.3,8.75,9.3h.53c4.23,0,8.29-1.68,11.28-4.67l1.29-1.29c5.83-5.83,15.28-5.83,21.1,0h0s-39.41,39.41-39.41,39.41c-5.13,5.13-8.09,12.03-8.28,19.28l-.63,24.44h-53.44v-87.18"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1801.48,2052.44l3.96-47.46c.33-3.98-2.63-7.48-6.61-7.81h0c-3.98-.33-7.48,2.63-7.81,6.61l-4.51,54.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1787.01,2052.44l1.45-63.07c.09-3.99-3.07-7.31-7.07-7.4h0c-3.99-.09-7.31,3.07-7.4,7.07l-1.53,66.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1772.54,2052.44l-2.33-71.6c-.13-3.99-3.47-7.13-7.47-7h0c-3.99.13-7.13,3.47-7,7.47l2.33,71.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1758.07,2052.44l-4.83-62.9c-.31-3.98-3.78-6.97-7.77-6.66h0c-3.98.31-6.97,3.78-6.66,7.77l3.86,62.51c.31,5.04-3.69,9.3-8.75,9.3h-.53c-4.23,0-8.29-1.68-11.28-4.67l-1.29-1.29c-5.83-5.83-15.28-5.83-21.1,0h0s39.41,39.41,39.41,39.41c5.13,5.13,8.09,12.03,8.28,19.28l.63,24.44h53.44s0-87.18,0-87.18"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1695.54,
    y1: 521.13,
    x2: 1695.54,
    y2: 676.92
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1695.54,500.16c-2.21,0-4.42-.05-6.61-.13l2.67,21.11h7.88l2.67-21.11c-2.2.08-4.4.13-6.61.13Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1660.56,
    y: 174.55,
    width: 0,
    height: 0,
    transform: "translate(822.69 1618.81) rotate(-65.88)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 811.82,
    y1: 314.38,
    x2: 987.87,
    y2: 314.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M821.85,300.11c-1.32,0-2.53-.33-3.63-.99-1.1-.66-1.98-1.54-2.64-2.64s-.99-2.32-.99-3.66c0-.69.08-1.33.24-1.92.16-.59.42-1.19.76-1.79l5.79-10.05h4.18l-3.88,6.72c.8-.06,1.57,0,2.3.21s1.42.51,2.05.93c.63.42,1.18.93,1.65,1.54s.84,1.27,1.1,2.01.39,1.53.39,2.36c0,1-.19,1.94-.57,2.82s-.9,1.65-1.57,2.33c-.67.67-1.45,1.2-2.33,1.58-.89.38-1.84.57-2.85.57ZM821.85,296.5c.72,0,1.36-.17,1.92-.52.56-.35,1-.8,1.32-1.37.32-.56.48-1.16.48-1.79,0-.68-.16-1.3-.49-1.86-.33-.56-.77-1.01-1.32-1.34-.56-.33-1.18-.5-1.88-.5s-1.36.17-1.91.52c-.56.35-.99.8-1.31,1.37-.31.56-.47,1.17-.47,1.82,0,.7.17,1.32.52,1.88.34.55.79.99,1.35,1.31.56.32,1.15.49,1.79.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M833.09,300.11c-.51,0-.95-.18-1.31-.54-.36-.36-.54-.8-.54-1.32s.18-.94.54-1.3c.36-.36.79-.55,1.31-.55s.95.18,1.31.55c.36.36.55.8.55,1.3s-.18.96-.55,1.32-.8.54-1.31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M844.84,300.11c-1.33,0-2.53-.32-3.6-.97-1.07-.64-1.92-1.5-2.55-2.58-.63-1.07-.94-2.25-.94-3.53h3.6c0,.64.16,1.22.47,1.75.31.53.74.95,1.26,1.25.53.31,1.11.47,1.75.47s1.22-.16,1.74-.47c.52-.31.94-.73,1.26-1.25.31-.53.47-1.11.47-1.75s-.13-1.23-.41-1.76c-.27-.54-.71-.96-1.31-1.29-.61-.32-1.41-.48-2.4-.48h-5.32l2.18-10.45h10.16v3.6h-7.24l-.66,3.25h1.46c1.4.06,2.63.4,3.71,1.03s1.91,1.47,2.52,2.53.91,2.25.91,3.57c0,.97-.18,1.88-.55,2.73s-.87,1.61-1.52,2.26-1.4,1.16-2.25,1.53-1.77.55-2.75.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M859.64,281.86v3.1h4.03v3.6h-4.03v11.16h-3.6v-11.16h-1.61v-3.6h1.61v-3.1c0-.85.21-1.62.63-2.33.42-.7.98-1.26,1.69-1.68.71-.42,1.49-.63,2.35-.63.62,0,1.24.13,1.85.38s1.15.65,1.62,1.18l-2.6,2.54c-.09-.17-.21-.29-.38-.38-.16-.08-.33-.12-.5-.12-.29,0-.53.1-.75.3-.21.2-.32.45-.32.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M874.51,288.56h-2.86v11.16h-3.6v-11.16h-2.19v-3.6h2.19v-4.64h3.6v4.64h2.86v3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M884.25,299.72v-14.77h3.6v1.31c.5-.53,1.1-.95,1.8-1.26.7-.31,1.45-.47,2.26-.47,1.02,0,1.97.24,2.83.72s1.55,1.13,2.06,1.93c.52-.81,1.21-1.45,2.07-1.93s1.8-.72,2.82-.72c1.08,0,2.06.26,2.95.79.88.53,1.58,1.23,2.11,2.11.53.88.79,1.86.79,2.95v9.33h-3.6v-8.37c0-.57-.14-1.1-.42-1.57-.28-.48-.66-.86-1.12-1.15-.47-.29-.99-.44-1.57-.44s-1.1.14-1.57.42-.84.66-1.13,1.13c-.29.47-.43,1.01-.43,1.61v8.37h-3.6v-8.37c0-.6-.14-1.14-.41-1.61-.28-.47-.65-.85-1.12-1.13s-1-.42-1.58-.42-1.09.15-1.57.44c-.47.29-.85.67-1.13,1.15-.28.48-.42,1-.42,1.57v8.37h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M921.33,284.96h3.6v14.77h-3.6l-.16-1.83c-.4.66-.94,1.19-1.6,1.6-.66.41-1.45.61-2.35.61-1.09,0-2.12-.21-3.07-.62-.96-.41-1.79-.98-2.52-1.71-.72-.73-1.29-1.57-1.7-2.52-.41-.96-.61-1.98-.61-3.07s.19-2.04.58-2.97c.39-.92.93-1.74,1.63-2.44.7-.7,1.51-1.25,2.42-1.64s1.9-.59,2.95-.59c.97,0,1.85.22,2.62.65.77.43,1.43.98,1.97,1.65l-.16-1.89ZM917.12,296.64c.77,0,1.45-.19,2.04-.58.59-.38,1.05-.9,1.39-1.56.33-.65.5-1.38.5-2.16s-.17-1.52-.5-2.18c-.33-.66-.8-1.17-1.4-1.56-.6-.38-1.27-.58-2.03-.58s-1.45.19-2.08.58-1.12.91-1.49,1.56-.55,1.37-.55,2.17.19,1.52.56,2.17c.37.65.87,1.17,1.5,1.55.62.38,1.31.58,2.06.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M926.96,299.72l5.4-7.41-5.36-7.37h4.44l3.13,4.3,3.14-4.3h4.45l-5.36,7.37,5.4,7.41h-4.44l-3.19-4.37-3.17,4.37h-4.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M977.44,303.01l9.76,9.76c.88.88.88,2.32,0,3.2l-9.76,9.76"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 291.24,
    y1: 314.38,
    x2: 115.19,
    y2: 314.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M167.67,300.11c-1.32,0-2.53-.33-3.63-.99-1.1-.66-1.98-1.54-2.64-2.64s-.99-2.32-.99-3.66c0-.69.08-1.33.24-1.92.16-.59.42-1.19.76-1.79l5.79-10.05h4.18l-3.88,6.72c.8-.06,1.57,0,2.3.21s1.42.51,2.05.93c.63.42,1.18.93,1.65,1.54s.84,1.27,1.1,2.01.39,1.53.39,2.36c0,1-.19,1.94-.57,2.82s-.9,1.65-1.57,2.33c-.67.67-1.45,1.2-2.33,1.58-.89.38-1.84.57-2.85.57ZM167.67,296.5c.72,0,1.36-.17,1.92-.52.56-.35,1-.8,1.32-1.37.32-.56.48-1.16.48-1.79,0-.68-.16-1.3-.49-1.86-.33-.56-.77-1.01-1.32-1.34-.56-.33-1.18-.5-1.88-.5s-1.36.17-1.91.52c-.56.35-.99.8-1.31,1.37-.31.56-.47,1.17-.47,1.82,0,.7.17,1.32.52,1.88.34.55.79.99,1.35,1.31.56.32,1.15.49,1.79.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M178.91,300.11c-.51,0-.95-.18-1.31-.54-.36-.36-.54-.8-.54-1.32s.18-.94.54-1.3c.36-.36.79-.55,1.31-.55s.95.18,1.31.55c.36.36.55.8.55,1.3s-.18.96-.55,1.32-.8.54-1.31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M190.66,300.11c-1.33,0-2.53-.32-3.6-.97-1.07-.64-1.92-1.5-2.55-2.58-.63-1.07-.94-2.25-.94-3.53h3.6c0,.64.16,1.22.47,1.75.31.53.74.95,1.26,1.25.53.31,1.11.47,1.75.47s1.22-.16,1.74-.47c.52-.31.94-.73,1.26-1.25.31-.53.47-1.11.47-1.75s-.13-1.23-.41-1.76c-.27-.54-.71-.96-1.31-1.29-.61-.32-1.41-.48-2.4-.48h-5.32l2.18-10.45h10.16v3.6h-7.24l-.66,3.25h1.46c1.4.06,2.63.4,3.71,1.03s1.91,1.47,2.52,2.53.91,2.25.91,3.57c0,.97-.18,1.88-.55,2.73s-.87,1.61-1.52,2.26-1.4,1.16-2.25,1.53-1.77.55-2.75.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.46,281.86v3.1h4.03v3.6h-4.03v11.16h-3.6v-11.16h-1.61v-3.6h1.61v-3.1c0-.85.21-1.62.63-2.33.42-.7.98-1.26,1.69-1.68.71-.42,1.49-.63,2.35-.63.62,0,1.24.13,1.85.38s1.15.65,1.62,1.18l-2.6,2.54c-.09-.17-.21-.29-.38-.38-.16-.08-.33-.12-.5-.12-.29,0-.53.1-.75.3-.21.2-.32.45-.32.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M220.33,288.56h-2.86v11.16h-3.6v-11.16h-2.19v-3.6h2.19v-4.64h3.6v4.64h2.86v3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M230.07,299.72v-14.77h3.6v1.31c.5-.53,1.1-.95,1.8-1.26.7-.31,1.45-.47,2.26-.47,1.02,0,1.97.24,2.83.72s1.55,1.13,2.06,1.93c.52-.81,1.21-1.45,2.07-1.93s1.8-.72,2.82-.72c1.08,0,2.06.26,2.95.79.88.53,1.58,1.23,2.11,2.11.53.88.79,1.86.79,2.95v9.33h-3.6v-8.37c0-.57-.14-1.1-.42-1.57-.28-.48-.66-.86-1.12-1.15-.47-.29-.99-.44-1.57-.44s-1.1.14-1.57.42-.84.66-1.13,1.13c-.29.47-.43,1.01-.43,1.61v8.37h-3.6v-8.37c0-.6-.14-1.14-.41-1.61-.28-.47-.65-.85-1.12-1.13s-1-.42-1.58-.42-1.09.15-1.57.44c-.47.29-.85.67-1.13,1.15-.28.48-.42,1-.42,1.57v8.37h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M267.15,284.96h3.6v14.77h-3.6l-.16-1.83c-.4.66-.94,1.19-1.6,1.6-.66.41-1.45.61-2.35.61-1.09,0-2.12-.21-3.07-.62-.96-.41-1.79-.98-2.52-1.71-.72-.73-1.29-1.57-1.7-2.52-.41-.96-.61-1.98-.61-3.07s.19-2.04.58-2.97c.39-.92.93-1.74,1.63-2.44.7-.7,1.51-1.25,2.42-1.64s1.9-.59,2.95-.59c.97,0,1.85.22,2.62.65.77.43,1.43.98,1.97,1.65l-.16-1.89ZM262.94,296.64c.77,0,1.45-.19,2.04-.58.59-.38,1.05-.9,1.39-1.56.33-.65.5-1.38.5-2.16s-.17-1.52-.5-2.18c-.33-.66-.8-1.17-1.4-1.56-.6-.38-1.27-.58-2.03-.58s-1.45.19-2.08.58-1.12.91-1.49,1.56-.55,1.37-.55,2.17.19,1.52.56,2.17c.37.65.87,1.17,1.5,1.55.62.38,1.31.58,2.06.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M272.78,299.72l5.4-7.41-5.36-7.37h4.44l3.13,4.3,3.14-4.3h4.45l-5.36,7.37,5.4,7.41h-4.44l-3.19-4.37-3.17,4.37h-4.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.62,303.01l-9.76,9.76c-.88.88-.88,2.32,0,3.2l9.76,9.76"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 1507.42,
    y1: 314.38,
    x2: 1201.36,
    y2: 314.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1387.12,299.72v-17.07h-2.6l.97-3.6h5.23v20.67h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1400.63,300.11c-1.25,0-2.38-.29-3.38-.89s-1.8-1.39-2.39-2.38c-.59-1-.89-2.11-.89-3.33h3.6c0,.55.13,1.05.39,1.51.26.45.62.81,1.09,1.08.46.27.99.41,1.58.41.54,0,1.05-.14,1.51-.41s.84-.63,1.13-1.08c.29-.45.43-.96.43-1.51,0-.72-.19-1.32-.58-1.79s-.92-.83-1.6-1.07c-.68-.24-1.48-.35-2.38-.35v-2.78c1.22,0,2.19-.23,2.9-.69.71-.46,1.07-1.14,1.07-2.04,0-.46-.12-.89-.35-1.27s-.55-.69-.94-.92c-.39-.23-.82-.35-1.28-.35s-.93.12-1.37.35c-.44.23-.8.54-1.09.92-.28.38-.42.81-.42,1.27h-3.6c0-.85.17-1.64.52-2.38s.82-1.4,1.42-1.96c.61-.56,1.29-1,2.07-1.32.77-.32,1.58-.48,2.43-.48,1.11,0,2.14.28,3.09.83.94.55,1.7,1.29,2.27,2.21.57.93.86,1.96.86,3.1,0,.8-.19,1.58-.56,2.35-.38.77-.91,1.31-1.59,1.62.6.22,1.1.58,1.51,1.08.4.51.71,1.08.92,1.73.21.64.32,1.29.32,1.94,0,1.21-.31,2.32-.92,3.32s-1.42,1.8-2.43,2.39c-1.01.6-2.12.89-3.33.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1414.14,281.86v3.1h4.03v3.6h-4.03v11.16h-3.6v-11.16h-1.61v-3.6h1.61v-3.1c0-.85.21-1.62.63-2.33.42-.7.98-1.26,1.69-1.68.71-.42,1.49-.63,2.35-.63.62,0,1.24.13,1.85.38s1.15.65,1.62,1.18l-2.6,2.54c-.09-.17-.21-.29-.38-.38-.16-.08-.33-.12-.5-.12-.29,0-.53.1-.75.3-.21.2-.32.45-.32.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1429.01,288.56h-2.86v11.16h-3.6v-11.16h-2.19v-3.6h2.19v-4.64h3.6v4.64h2.86v3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1438.76,299.72v-14.77h3.6v1.31c.5-.53,1.1-.95,1.8-1.26.7-.31,1.45-.47,2.26-.47,1.02,0,1.97.24,2.83.72s1.55,1.13,2.06,1.93c.52-.81,1.21-1.45,2.07-1.93s1.8-.72,2.82-.72c1.08,0,2.06.26,2.95.79.88.53,1.58,1.23,2.11,2.11.53.88.79,1.86.79,2.95v9.33h-3.6v-8.37c0-.57-.14-1.1-.42-1.57-.28-.48-.66-.86-1.12-1.15-.47-.29-.99-.44-1.57-.44s-1.1.14-1.57.42-.84.66-1.13,1.13c-.29.47-.43,1.01-.43,1.61v8.37h-3.6v-8.37c0-.6-.14-1.14-.41-1.61-.28-.47-.65-.85-1.12-1.13s-1-.42-1.58-.42-1.09.15-1.57.44c-.47.29-.85.67-1.13,1.15-.28.48-.42,1-.42,1.57v8.37h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1475.83,284.96h3.6v14.77h-3.6l-.16-1.83c-.4.66-.94,1.19-1.6,1.6-.66.41-1.45.61-2.35.61-1.09,0-2.12-.21-3.07-.62-.96-.41-1.79-.98-2.52-1.71-.72-.73-1.29-1.57-1.7-2.52-.41-.96-.61-1.98-.61-3.07s.19-2.04.58-2.97c.39-.92.93-1.74,1.63-2.44.7-.7,1.51-1.25,2.42-1.64s1.9-.59,2.95-.59c.97,0,1.85.22,2.62.65.77.43,1.43.98,1.97,1.65l-.16-1.89ZM1471.63,296.64c.77,0,1.45-.19,2.04-.58.59-.38,1.05-.9,1.39-1.56.33-.65.5-1.38.5-2.16s-.17-1.52-.5-2.18c-.33-.66-.8-1.17-1.4-1.56-.6-.38-1.27-.58-2.03-.58s-1.45.19-2.08.58-1.12.91-1.49,1.56-.55,1.37-.55,2.17.19,1.52.56,2.17c.37.65.87,1.17,1.5,1.55.62.38,1.31.58,2.06.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1481.46,299.72l5.4-7.41-5.36-7.37h4.44l3.13,4.3,3.14-4.3h4.45l-5.36,7.37,5.4,7.41h-4.44l-3.19-4.37-3.17,4.37h-4.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1211.79,303.01l-9.76,9.76c-.88.88-.88,2.32,0,3.2l9.76,9.76"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1662.62,
    cy: 314.31,
    rx: 20.31,
    ry: 185.71
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1638.56,
    cy: 314.31,
    rx: 20.31,
    ry: 185.71
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1605.21,
    cy: 314.31,
    rx: 20.31,
    ry: 185.71
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1547.72,
    cy: 314.31,
    rx: 20.31,
    ry: 185.71
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1707.8,128.6h-44.98v.02c11.12.98,20.11,83.73,20.11,185.69s-8.98,184.71-20.11,185.69v.02h44.98c11.22,0,20.31-83.15,20.31-185.71s-9.09-185.71-20.31-185.71Z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1369.81,882.62c0,62.31,5.52,112.82,12.34,112.82h27.33s0-.01,0-.01c.04,0,.08.01.12.01,6.81,0,12.34-50.51,12.34-112.82,0-62.31-5.52-112.82-12.34-112.82-.04,0-.08.01-.12.01h0s-27.33-.01-27.33-.01c-6.81,0-12.34,50.51-12.34,112.82ZM1397.26,882.62c0-1.94,0-3.87.02-5.79-.01,1.92-.02,3.85-.02,5.79,0,1.94,0,3.87.02,5.79-.01-1.92-.02-3.85-.02-5.79ZM1403.14,978.75s0,0,0,0c0,0,0,0,0,0ZM1402.89,977.29s0,.02,0,.03c0,0,0-.02,0-.03ZM1402.64,975.8s0,.01,0,.02c0,0,0-.01,0-.02ZM1402.4,974.21s0,.04,0,.06c0-.02,0-.04,0-.06ZM1402.16,972.59s0,.06.01.09c0-.03,0-.06-.01-.09ZM1401.92,970.94s0,.06.01.09c0-.03,0-.06-.01-.09ZM1401.69,969.2s.01.09.02.14c0-.05-.01-.09-.02-.14ZM1401.46,967.42c0,.06.01.12.02.18,0-.06-.01-.12-.02-.18ZM1401.24,965.61c0,.06.01.13.02.19,0-.06-.01-.13-.02-.19ZM1401.03,963.74c0,.07.02.14.02.22,0-.07-.02-.14-.02-.22ZM1400.81,961.81c0,.09.02.18.03.27,0-.09-.02-.18-.03-.27ZM1400.61,959.88c0,.09.02.18.03.27,0-.09-.02-.18-.03-.27ZM1400.41,957.88c0,.1.02.19.03.29,0-.1-.02-.19-.03-.29ZM1400.21,955.8c.01.12.02.24.03.36-.01-.12-.02-.24-.03-.36ZM1400.02,953.69c.01.14.02.27.04.41-.01-.14-.02-.27-.04-.41ZM1399.83,951.54c.01.16.03.31.04.47-.01-.16-.03-.31-.04-.47ZM1399.65,949.37c.01.16.03.33.04.49-.01-.16-.03-.32-.04-.49ZM1399.48,947.12c.01.19.03.38.04.56-.01-.19-.03-.38-.04-.56ZM1399.31,944.88c.01.19.03.38.04.57-.01-.19-.03-.38-.04-.57ZM1399.15,942.58c.01.21.03.41.04.62-.01-.21-.03-.41-.04-.62ZM1398.99,940.24c.01.22.03.45.04.67-.01-.22-.03-.45-.04-.67ZM1398.85,937.92c.01.21.03.43.04.64-.01-.21-.03-.43-.04-.64ZM1398.7,935.48c.01.24.03.48.04.71-.01-.24-.03-.48-.04-.71ZM1398.56,932.99c.01.27.03.54.04.81-.01-.27-.03-.54-.04-.81ZM1398.43,930.48c.01.29.03.59.04.88-.02-.29-.03-.59-.04-.88ZM1398.3,927.91c.02.33.03.66.05.99-.02-.33-.03-.66-.05-.99ZM1398.18,925.42c.01.32.03.65.04.97-.01-.32-.03-.65-.04-.97ZM1398.07,922.86c.01.33.03.66.04.98-.01-.33-.03-.66-.04-.98ZM1397.97,920.22c.01.35.03.71.04,1.06-.01-.35-.03-.71-.04-1.06ZM1397.87,917.62c.01.35.02.71.04,1.06-.01-.35-.03-.71-.04-1.06ZM1397.78,914.95c.01.37.02.74.04,1.1-.01-.37-.02-.74-.04-1.1ZM1397.69,912.14c.01.42.02.85.04,1.27-.01-.42-.03-.85-.04-1.27ZM1397.61,909.4c.01.45.02.9.04,1.34-.01-.45-.02-.89-.04-1.34ZM1397.55,906.67c.01.45.02.9.03,1.35-.01-.45-.02-.9-.03-1.35ZM1397.48,903.84c.01.49.02.97.03,1.46-.01-.48-.02-.97-.03-1.46ZM1397.43,901.03c0,.5.02,1,.03,1.5,0-.5-.02-1-.03-1.5ZM1397.38,898.33c0,.47.01.95.02,1.42,0-.47-.01-.95-.02-1.42ZM1397.34,895.55c0,.46.01.93.02,1.39,0-.46-.01-.93-.02-1.39ZM1397.31,892.73c0,.47,0,.93.01,1.4,0-.46,0-.93-.01-1.4ZM1397.29,889.82c0,.49,0,.97.01,1.46,0-.48,0-.97-.01-1.46ZM1403.14,786.5s0,0,0,0c0,0,0,0,0,0ZM1402.89,787.96s0-.02,0-.03c0,0,0,.02,0,.03ZM1402.64,789.45s0-.01,0-.02c0,0,0,.01,0,.02ZM1402.4,791.04s0-.04,0-.06c0,.02,0,.04,0,.06ZM1402.16,792.66s0-.06.01-.09c0,.03,0,.06-.01.09ZM1401.92,794.31s0-.06.01-.09c0,.03,0,.06-.01.09ZM1401.69,796.05s.01-.09.02-.14c0,.05-.01.09-.02.14ZM1401.46,797.83c0-.06.01-.12.02-.18,0,.06-.01.12-.02.18ZM1401.24,799.64c0-.06.01-.13.02-.19,0,.06-.01.13-.02.19ZM1401.03,801.5c0-.07.02-.14.02-.22,0,.07-.02.14-.02.22ZM1400.81,803.43c0-.09.02-.18.03-.27,0,.09-.02.18-.03.27ZM1400.61,805.37c0-.09.02-.18.03-.27,0,.09-.02.18-.03.27ZM1400.41,807.37c0-.1.02-.19.03-.29,0,.1-.02.19-.03.29ZM1400.21,809.45c.01-.12.02-.24.03-.36-.01.12-.02.24-.03.36ZM1400.02,811.56c.01-.14.02-.27.04-.41-.01.14-.02.27-.04.41ZM1399.83,813.71c.01-.16.03-.31.04-.47-.01.16-.03.31-.04.47ZM1399.65,815.87c.01-.16.03-.33.04-.49-.01.16-.03.32-.04.49ZM1399.48,818.13c.01-.19.03-.38.04-.56-.01.19-.03.38-.04.56ZM1399.31,820.36c.01-.19.03-.38.04-.57-.01.19-.03.38-.04.57ZM1399.15,822.67c.01-.21.03-.41.04-.62-.01.21-.03.41-.04.62ZM1398.99,825.01c.01-.22.03-.45.04-.67-.01.22-.03.45-.04.67ZM1398.85,827.32c.01-.21.03-.43.04-.64-.01.21-.03.43-.04.64ZM1398.7,829.77c.01-.24.03-.48.04-.71-.01.24-.03.48-.04.71ZM1398.56,832.26c.01-.27.03-.54.04-.81-.01.27-.03.54-.04.81ZM1398.43,834.77c.01-.29.03-.59.04-.88-.02.29-.03.59-.04.88ZM1398.3,837.34c.02-.33.03-.66.05-.99-.02.33-.03.66-.05.99ZM1398.18,839.83c.01-.32.03-.65.04-.97-.01.32-.03.65-.04.97ZM1398.07,842.39c.01-.33.03-.66.04-.98-.01.33-.03.66-.04.98ZM1397.97,845.03c.01-.35.03-.71.04-1.06-.01.35-.03.71-.04,1.06ZM1397.87,847.62c.01-.35.02-.71.04-1.06-.01.35-.03.71-.04,1.06ZM1397.78,850.3c.01-.37.02-.74.04-1.1-.01.37-.02.74-.04,1.1ZM1397.69,853.11c.01-.42.02-.85.04-1.27-.01.42-.03.85-.04,1.27ZM1397.61,855.85c.01-.45.02-.9.04-1.34-.01.45-.02.89-.04,1.34ZM1397.55,858.58c.01-.45.02-.9.03-1.35-.01.45-.02.9-.03,1.35ZM1397.48,861.41c.01-.49.02-.97.03-1.46-.01.48-.02.97-.03,1.46ZM1397.43,864.21c0-.5.02-1,.03-1.5,0,.5-.02,1-.03,1.5ZM1397.38,866.92c0-.47.01-.95.02-1.42,0,.47-.01.95-.02,1.42ZM1397.34,869.69c0-.46.01-.93.02-1.39,0,.46-.01.93-.02,1.39ZM1397.31,872.52c0-.47,0-.93.01-1.4,0,.46,0,.93-.01,1.4ZM1397.29,875.43c0-.49,0-.97.01-1.46,0,.48,0,.97-.01,1.46Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1389.6,
    y1: 1008.27,
    x2: 1389.6,
    y2: 1102.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1389.6,995.53c1.35,0,2.68-.03,4.02-.08l-1.62,12.82h-4.79s-1.62-12.82-1.62-12.82c1.33.05,2.67.08,4.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1382.15,769.8h27.33c-6.76.61-12.22,50.88-12.22,112.82,0,61.94,5.46,112.21,12.22,112.81h0s-27.33.01-27.33.01c-6.81,0-12.34-50.51-12.34-112.82,0-62.31,5.52-112.82,12.34-112.82Z"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 551.53,
    cy: 314.38,
    r: 235.75
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 551.53,
    cy: 314.38,
    r: 212.98
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 595.72,
    cy: 890.76,
    r: 83.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 595.72,
    cy: 890.76,
    r: 68.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 595.72,
    y1: 967.12,
    x2: 595.72,
    y2: 1059.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M595.72,959.37c-.82,0-1.63-.02-2.44-.05l.99,7.79h2.91l.99-7.79c-.81.03-1.62.05-2.44.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 630.21,
    y1: 903.4,
    x2: 907.26,
    y2: 903.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M898.27,893.6l8.42,8.42c.76.76.76,2,0,2.76l-8.42,8.42"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 595.72,
    cy: 890.76,
    r: 105.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 120.41,
    y: 786.89,
    width: 441.28,
    height: 273.03,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 120.41,
    y1: 1031.83,
    x2: 561.69,
    y2: 1031.83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 716.69,
    cy: 785.64,
    r: 15.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 722.97,
    y1: 791.92,
    x2: 710.41,
    y2: 779.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 710.41,
    y1: 791.92,
    x2: 722.97,
    y2: 779.36
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1050.41,
    cy: 890.76,
    r: 83.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1050.41,
    cy: 890.76,
    r: 68.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1050.41,
    y1: 967.12,
    x2: 1050.41,
    y2: 1059.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1050.41,959.37c-.82,0-1.63-.02-2.44-.05l.99,7.79h2.91l.99-7.79c-.81.03-1.62.05-2.44.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1050.41,
    cy: 890.76,
    r: 105.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1171.38,
    cy: 785.64,
    r: 15.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "1178.98 781.78 1168.95 791.12 1163.77 787.26"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1050.41,
    cy: 890.76,
    r: 132.05
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 784.29,
    cy: 1400.35,
    r: 131.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 784.29,
    cy: 1400.35,
    r: 107.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 784.29,
    y1: 1519.85,
    x2: 784.29,
    y2: 1665.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M784.29,1507.72c-1.28,0-2.55-.03-3.82-.07l1.54,12.2h4.55l1.54-12.2c-1.27.04-2.54.07-3.82.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 838.26,
    y1: 1420.12,
    x2: 1271.86,
    y2: 1420.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1257.79,1404.79l13.18,13.18c1.19,1.19,1.19,3.12,0,4.32l-13.18,13.18"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 784.29,
    cy: 1400.35,
    r: 164.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 973.6,
    cy: 1235.83,
    r: 24.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 983.43,
    y1: 1245.66,
    x2: 963.77,
    y2: 1226
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 963.77,
    y1: 1245.66,
    x2: 983.43,
    y2: 1226
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1555.9,
    cy: 1400.35,
    r: 131.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1555.9,
    cy: 1400.35,
    r: 107.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1555.9,
    y1: 1519.85,
    x2: 1555.9,
    y2: 1665.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1555.9,1507.72c-1.28,0-2.55-.03-3.82-.07l1.54,12.2h4.55l1.54-12.2c-1.27.04-2.54.07-3.82.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1555.9,
    cy: 1400.35,
    r: 164.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1745.21,
    cy: 1235.83,
    r: 24.79
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "1757.11 1229.78 1741.41 1244.41 1733.3 1238.36"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1555.9,
    cy: 1400.35,
    r: 206.66
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1456.46,
    cy: 785.64,
    r: 15.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1462.74,
    y1: 791.92,
    x2: 1450.18,
    y2: 779.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1450.18,
    y1: 791.92,
    x2: 1462.74,
    y2: 779.36
  })))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1717.47,
    cy: 900.99,
    rx: 28.54,
    ry: 154.6
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1497.82,
    cy: 882.62,
    rx: 12.07,
    ry: 112.82
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 1560.28,
    cy: 882.62,
    rx: 12.07,
    ry: 112.82
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1630.64,
    cy: 882.62,
    rx: 12.07,
    ry: 112.82
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1727.39,
    y1: 867.36,
    x2: 1698.63,
    y2: 934.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1726.87,
    y1: 904.29,
    x2: 1700.17,
    y2: 969.81
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1751.8,769.8h-27.33s-.08,0-.12,0c-6.81,0-12.34,50.51-12.34,112.82s5.52,112.82,12.34,112.82c.04,0,.08-.01.12-.01h0s27.33.01,27.33.01c6.81,0,12.34-50.51,12.34-112.82s-5.52-112.82-12.34-112.82ZM1736.67,888.41c.01-1.92.02-3.85.02-5.79s0-3.87-.02-5.79c.01,1.92.02,3.85.02,5.79s0,3.87-.02,5.79ZM1730.81,978.75s0,0,0,0c0,0,0,0,0,0ZM1731.06,977.31s0-.02,0-.03c0,0,0,.02,0,.03ZM1731.3,975.81s0-.01,0-.02c0,0,0,.01,0,.02ZM1731.54,974.27s0-.04,0-.06c0,.02,0,.04,0,.06ZM1731.78,972.68s0-.06.01-.09c0,.03,0,.06-.01.09ZM1732.01,971.03s0-.06.01-.09c0,.03,0,.06-.01.09ZM1732.24,969.34s.01-.09.02-.14c0,.05-.01.09-.02.14ZM1732.46,967.6c0-.06.01-.12.02-.18,0,.06-.01.12-.02.18ZM1732.68,965.8c0-.06.01-.13.02-.19,0,.06-.01.13-.02.19ZM1732.9,963.96c0-.07.02-.14.02-.22,0,.07-.02.14-.02.22ZM1733.1,962.08c0-.09.02-.18.03-.27,0,.09-.02.18-.03.27ZM1733.31,960.15c0-.09.02-.18.03-.27,0,.09-.02.18-.03.27ZM1733.51,958.17c0-.1.02-.19.03-.29,0,.1-.02.19-.03.29ZM1733.7,956.16c.01-.12.02-.24.03-.36-.01.12-.02.24-.03.36ZM1733.89,954.1c.01-.14.02-.27.04-.41-.01.14-.02.27-.04.41ZM1734.08,952.01c.01-.16.03-.31.04-.47-.01.16-.03.31-.04.47ZM1734.25,949.86c.01-.16.03-.32.04-.49-.01.16-.03.33-.04.49ZM1734.43,947.69c.01-.19.03-.38.04-.56-.01.19-.03.38-.04.56ZM1734.59,945.46c.01-.19.03-.38.04-.57-.01.19-.03.38-.04.57ZM1734.76,943.2c.01-.21.03-.41.04-.62-.01.21-.03.41-.04.62ZM1734.91,940.91c.01-.22.03-.45.04-.67-.01.22-.03.45-.04.67ZM1735.06,938.56c.01-.21.03-.43.04-.64-.01.21-.03.43-.04.64ZM1735.21,936.19c.01-.24.03-.48.04-.71-.01.24-.03.48-.04.71ZM1735.34,933.8c.01-.27.03-.54.04-.81-.01.27-.03.54-.04.81ZM1735.48,931.36c.02-.29.03-.59.04-.88-.01.29-.03.59-.04.88ZM1735.6,928.9c.02-.33.03-.66.05-.99-.02.33-.03.66-.05.99ZM1735.72,926.39c.01-.32.03-.65.04-.97-.01.32-.03.65-.04.97ZM1735.83,923.84c.01-.33.03-.66.04-.98-.01.33-.03.66-.04.98ZM1735.94,921.28c.01-.35.03-.71.04-1.06-.01.35-.03.71-.04,1.06ZM1736.04,918.68c.01-.35.03-.71.04-1.06-.01.35-.02.71-.04,1.06ZM1736.13,916.06c.01-.37.02-.74.04-1.1-.01.37-.02.74-.04,1.1ZM1736.22,913.41c.01-.42.03-.85.04-1.27-.01.42-.02.85-.04,1.27ZM1736.3,910.74c.01-.45.02-.89.04-1.34-.01.45-.02.9-.04,1.34ZM1736.37,908.02c.01-.45.02-.9.03-1.35-.01.45-.02.9-.03,1.35ZM1736.43,905.29c.01-.48.02-.97.03-1.46-.01.49-.02.97-.03,1.46ZM1736.49,902.54c0-.5.02-1,.03-1.5,0,.5-.02,1-.03,1.5ZM1736.54,899.76c0-.47.01-.95.02-1.42,0,.47-.01.95-.02,1.42ZM1736.59,896.94c0-.46.01-.93.02-1.39,0,.46-.01.93-.02,1.39ZM1736.62,894.12c0-.46,0-.93.01-1.4,0,.47,0,.93-.01,1.4ZM1736.65,891.27c0-.48,0-.97.01-1.46,0,.49,0,.97-.01,1.46ZM1730.81,786.49s0,0,0,0c0,0,0,0,0,0ZM1731.06,787.93s0,.02,0,.03c0,0,0-.02,0-.03ZM1731.3,789.43s0,.01,0,.02c0,0,0-.01,0-.02ZM1731.54,790.97s0,.04,0,.06c0-.02,0-.04,0-.06ZM1731.78,792.57s0,.06.01.09c0-.03,0-.06-.01-.09ZM1732.01,794.22s0,.06.01.09c0-.03,0-.06-.01-.09ZM1732.24,795.91s.01.09.02.14c0-.05-.01-.09-.02-.14ZM1732.46,797.65c0,.06.01.12.02.18,0-.06-.01-.12-.02-.18ZM1732.68,799.45c0,.06.01.13.02.19,0-.06-.01-.13-.02-.19ZM1732.9,801.29c0,.07.02.14.02.22,0-.07-.02-.14-.02-.22ZM1733.1,803.17c0,.09.02.18.03.27,0-.09-.02-.18-.03-.27ZM1733.31,805.1c0,.09.02.18.03.27,0-.09-.02-.18-.03-.27ZM1733.51,807.08c0,.1.02.19.03.29,0-.1-.02-.19-.03-.29ZM1733.7,809.09c.01.12.02.24.03.36-.01-.12-.02-.24-.03-.36ZM1733.89,811.15c.01.14.02.27.04.41-.01-.14-.02-.27-.04-.41ZM1734.08,813.24c.01.16.03.31.04.47-.01-.16-.03-.31-.04-.47ZM1734.25,815.39c.01.16.03.32.04.49-.01-.16-.03-.33-.04-.49ZM1734.43,817.56c.01.19.03.38.04.56-.01-.19-.03-.38-.04-.56ZM1734.59,819.79c.01.19.03.38.04.57-.01-.19-.03-.38-.04-.57ZM1734.76,822.05c.01.21.03.41.04.62-.01-.21-.03-.41-.04-.62ZM1734.91,824.34c.01.22.03.45.04.67-.01-.22-.03-.45-.04-.67ZM1735.06,826.69c.01.21.03.43.04.64-.01-.21-.03-.43-.04-.64ZM1735.21,829.05c.01.24.03.48.04.71-.01-.24-.03-.48-.04-.71ZM1735.34,831.45c.01.27.03.54.04.81-.01-.27-.03-.54-.04-.81ZM1735.48,833.89c.02.29.03.59.04.88-.01-.29-.03-.59-.04-.88ZM1735.6,836.35c.02.33.03.66.05.99-.02-.33-.03-.66-.05-.99ZM1735.72,838.86c.01.32.03.65.04.97-.01-.32-.03-.65-.04-.97ZM1735.83,841.4c.01.33.03.66.04.98-.01-.33-.03-.66-.04-.98ZM1735.94,843.96c.01.35.03.71.04,1.06-.01-.35-.03-.71-.04-1.06ZM1736.04,846.56c.01.35.03.71.04,1.06-.01-.35-.02-.71-.04-1.06ZM1736.13,849.19c.01.37.02.74.04,1.1-.01-.37-.02-.74-.04-1.1ZM1736.22,851.84c.01.42.03.85.04,1.27-.01-.42-.02-.85-.04-1.27ZM1736.3,854.51c.01.45.02.89.04,1.34-.01-.45-.02-.9-.04-1.34ZM1736.37,857.22c.01.45.02.9.03,1.35-.01-.45-.02-.9-.03-1.35ZM1736.43,859.95c.01.48.02.97.03,1.46-.01-.49-.02-.97-.03-1.46ZM1736.49,862.71c0,.5.02,1,.03,1.5,0-.5-.02-1-.03-1.5ZM1736.54,865.49c0,.47.01.95.02,1.42,0-.47-.01-.95-.02-1.42ZM1736.59,868.3c0,.46.01.93.02,1.39,0-.46-.01-.93-.02-1.39ZM1736.62,871.13c0,.46,0,.93.01,1.4,0-.47,0-.93-.01-1.4ZM1736.65,873.97c0,.48,0,.97.01,1.46,0-.49,0-.97-.01-1.46Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1744.35,
    y1: 1008.27,
    x2: 1744.35,
    y2: 1102.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1744.35,995.53c-1.35,0-2.68-.03-4.02-.08l1.62,12.82h4.79s1.62-12.82,1.62-12.82c-1.33.05-2.67.08-4.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1751.8,769.8h-27.33c6.76.61,12.22,50.88,12.22,112.82s-5.46,112.21-12.22,112.81h0s27.33.01,27.33.01c6.81,0,12.34-50.51,12.34-112.82s-5.52-112.82-12.34-112.82Z"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 120.41,
    y: 1333.98,
    width: 441.28,
    height: 28.44,
    rx: 10,
    ry: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 120.41,
    y: 1412.02,
    width: 441.28,
    height: 28.44,
    rx: 10,
    ry: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 471.49,
    y1: 1333.98,
    x2: 444.08,
    y2: 1361.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 225.51,
    y1: 1412.53,
    x2: 198.09,
    y2: 1439.95
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 549.91,
    y1: 1412.53,
    x2: 522.5,
    y2: 1439.95
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 195.22,
    y1: 1412.53,
    x2: 167.81,
    y2: 1439.95
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 498.91,
    y1: 1333.98,
    x2: 471.49,
    y2: 1361.4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 567.76,
    y1: 1321.09,
    x2: 583.62,
    y2: 1300.28
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 576.08,
    y1: 1337.67,
    x2: 601.47,
    y2: 1339.36
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M249.33,1420.35v217.32h260.41v-234.95h-242.79c-9.73,0-17.62,7.89-17.62,17.62Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 249.33,
    y1: 1659.7,
    x2: 249.33,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 509.74,
    y1: 1659.7,
    x2: 509.74,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 493.46,
    y1: 1659.7,
    x2: 493.46,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 379.53,
    y1: 1659.7,
    x2: 379.53,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 314.43,
    y1: 1659.7,
    x2: 314.43,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 444.63,
    y1: 1659.7,
    x2: 444.63,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 428.36,
    y1: 1659.7,
    x2: 428.36,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 412.08,
    y1: 1659.7,
    x2: 412.08,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 395.81,
    y1: 1659.7,
    x2: 395.81,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 477.19,
    y1: 1659.7,
    x2: 477.19,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 460.91,
    y1: 1659.7,
    x2: 460.91,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 346.98,
    y1: 1659.7,
    x2: 346.98,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 281.88,
    y1: 1659.7,
    x2: 281.88,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 265.6,
    y1: 1659.7,
    x2: 265.6,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 298.15,
    y1: 1659.7,
    x2: 298.15,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 330.7,
    y1: 1659.7,
    x2: 330.7,
    y2: 1637.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 363.26,
    y1: 1659.7,
    x2: 363.26,
    y2: 1637.67
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 509.74,
    y: 1440.46,
    width: 18.33,
    height: 161.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/guidelines.6daaaa628270de7cba30d514e18c208f.svg";
export { ForwardRef as ReactComponent };